import { Link } from "react-router-dom";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";
import { MessageCircle, ArrowRight } from "lucide-react";

const faqs = [
  {
    question: "Qual a diferença entre certificado A1 e A3?",
    answer:
      "O certificado A1 é armazenado no computador, tem validade de 1 ano e permite cópias. Já o A3 fica em mídia física (token ou cartão), tem validade de 2 anos e oferece maior segurança, ideal para grandes volumes de transações.",
  },
  {
    question: "Em quanto tempo recebo meu certificado?",
    answer:
      "Certificados A1 são emitidos em poucos minutos após a validação dos documentos. Para A3, você agenda a videoconferência de validação e, após aprovada, o certificado é instalado na mídia escolhida.",
  },
  {
    question: "Posso parcelar a compra?",
    answer:
      "Sim! Você pode parcelar seu certificado digital em até 12x no cartão no cartão de crédito.",
  },
  {
    question: "Como funciona o suporte após a compra?",
    answer:
      "Oferecemos suporte técnico especializado via telefone, WhatsApp e e-mail. Nossa equipe auxilia desde a instalação até a resolução de dúvidas sobre uso do certificado.",
  },
  {
    question: "O que é necessário para comprar um certificado digital?",
    answer:
      "Para emissão online basta a CNH emitida após 2017 — os demais documentos da empresa (para PJ/MEI) são solicitados na própria videoconferência, sem burocracia. Para emissão presencial: qualquer documento oficial com foto e fé pública dentro da validade (RG, CPF, carteira de classe, carteira de trabalho ou passaporte).",
  },
  {
    question: "Meu certificado é aceito em todos os órgãos públicos?",
    answer:
      "Sim! Os certificados são emitidos pela SoluxID — Autoridade Certificadora credenciada pela ICP-Brasil — e aceitos em Receita Federal, INSS, e-CAC, bancos, cartórios e demais órgãos públicos e privados.",
  },
];

export const FAQ = () => {
  return (
    <section className="py-12 md:py-20 bg-muted/30">
      <div className="container max-w-4xl">
        <div className="text-center mb-6 md:mb-10">
          <h2 className="text-2xl md:text-4xl font-bold text-foreground mb-3 md:mb-4">
            Dúvidas Frequentes
          </h2>
          <p className="text-sm md:text-base text-muted-foreground">
            Toque em qualquer pergunta pra ver a resposta.
          </p>
        </div>

        <Accordion type="single" collapsible className="w-full space-y-2">
          {faqs.map((faq, index) => (
            <AccordionItem
              key={index}
              value={`item-${index}`}
              className="rounded-xl border bg-card px-4 data-[state=open]:shadow-sm"
            >
              <AccordionTrigger className="text-left font-semibold hover:no-underline py-4">
                {faq.question}
              </AccordionTrigger>
              <AccordionContent className="text-muted-foreground leading-relaxed pb-4">
                {faq.answer}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>

        {/* Helpful escape hatch — oculto no mobile (pedido do cliente) */}
        <div className="hidden md:block mt-10 rounded-2xl border-2 border-dashed border-primary/30 bg-primary/5 p-6 text-center">
          <p className="text-sm text-muted-foreground mb-3">
            Não encontrou o que procurava?
          </p>
          <Link
            to="/contato-e-suporte"
            className="inline-flex items-center gap-2 rounded-full bg-primary px-6 py-2.5 text-sm font-bold text-primary-foreground shadow-md hover:bg-primary/90 transition-colors"
          >
            <MessageCircle className="h-4 w-4" /> Falar com especialista
            <ArrowRight className="h-4 w-4" />
          </Link>
        </div>
      </div>
    </section>
  );
};
